<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-2 mt-1 px-1">
      <div class="d-flex align-items-center">
        <feather-icon icon="TruckIcon" size="26" class="text-primary mr-75" />
        <h3 class="mb-0 text-primary font-weight-bolder">Planilla Operativa</h3>
      </div>
      <div class="d-flex align-items-center gap-x-2">
        <b-badge variant="light-primary" class="px-1 py-1 d-flex align-items-center" style="font-size: 1rem; border-radius: 8px;">
          <feather-icon icon="UsersIcon" class="mr-50" />
          Registros: {{ paginate.of }}
        </b-badge>
      </div>
    </div>

    <filter-slot :filter="filters" :filterPrincipal="filterPrincipal" :paginate="paginate"
      class="card-app-design"
      @reload="$refs['ref-table-rrhh-operations-payroll'].refresh()">
      <template #buttons>
        <div class="d-flex align-items-center justify-content-start flex-wrap my-1 gap-1">
          <b-dropdown variant="outline-primary" size="sm" no-caret menu-class="dropdown-menu-luxury shadow-lg border-0" toggle-class="rounded-pill px-1">
            <template #button-content>
              <feather-icon icon="ColumnsIcon" size="16" class="mr-50" />
              <span>Columnas</span>
              <b-badge variant="primary" pill class="ml-50">{{ showFieldsArray.length }}</b-badge>
            </template>
            <div class="custom-scrollbar px-1" style="max-height: 50vh; overflow-y: auto; overflow-x: hidden;">
              <h6 class="dropdown-header px-0 mb-1 text-primary border-bottom pb-50">Visibilidad de Columnas</h6>
              <div v-for="field in showFields" :key="field.key" class="my-50">
                <b-form-checkbox v-model="showFieldsArray" :value="field.key" class="custom-control-primary text-nowrap">
                  <span class="font-small-3 text-body">{{ field.label == "" ? "Selección" : field.label }}</span>
                </b-form-checkbox>
              </div>
            </div>
          </b-dropdown>
        </div>
      </template>

      <template #table>
        <b-table ref="ref-table-rrhh-operations-payroll" :per-page="paginate.perPage"
          :current-page="paginate.currentPage" sticky-header="50vh" small class="position-relative font-small-3" hover
          table-class="text-nowrap" :busy.sync="isBusy" :items="myProvider" :fields="tableFields" :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc" primary-key="id" show-empty :tbody-tr-class="resolveStyleRow">
          <template #table-busy>
            <b-skeleton-table :headers="fields" :rows="paginate.perPage" :columns="fields.length"
              :table-props="{ bordered: true, striped: true }" />
          </template>

          <template #empty="scope">
            <div class="d-flex justify-content-center align-items-center" style="height: 250px">
              <span class="text-muted" style="font-size: 16px">No se encontraron registros coincidentes</span>
            </div>
          </template>

          <template #cell(full_name)="data">
            <div class="d-flex align-items-center py-25">
              <b-avatar size="32" :variant="data.item.fecha_cese ? 'light-danger' : 'light-success'" class="mr-1 shadow-sm">
                <feather-icon icon="UserIcon" size="16" />
              </b-avatar>
              <div class="d-flex flex-column">
                <router-link target="_blank" :class="[textLink, 'font-weight-bolder']" :to="{
                  name: 'rrhh-employees-information',
                  params: { id: data.item.employee_id },
                }" style="font-size: 0.95rem;">
                  {{ data.item.full_name | capitalize }}
                </router-link>
                <small class="text-muted d-flex align-items-center">
                  <feather-icon icon="HashIcon" size="10" class="mr-25" />
                  {{ data.item.document_number }}
                </small>
              </div>
            </div>
          </template>

          <template #cell(fecha_cese)="data">
            <span class="text-danger" style="opacity: 0.6; font-size: 11px" v-if="data.item.fecha_cese != null"> Trabajador cesado: {{
                data.item.fecha_cese | prettyDateWithoutTime }} </span>
                <span v-else class="text-primary">
                  Activo
                </span>
          </template>

          <template #cell(codigo_empleado)="data">
            <span class="text-primary"> # {{ data.item.personal_code }} </span>
          </template>

          <template #cell(personal_type)="data">
            <span>
              {{ $t(data.item.personal_type) }}
            </span>
            <span v-if="
              data.item.personal_type == 'Stevedore' &&
              data.item.stever_type_id != null
            ">
              <br />
              <span style="opacity: 0.5">
                {{
                  (() => {
                    switch (data.item.stever_type_id) {
                      case 1:
                        return "ESTIBADOR LOCAL";
                      case 2:
                        return "ESTIBADOR NESTLE";
                      case 3:
                        return "ESTIBADOR AREQUIPA";
                    }
                  })()
                }}
              </span>
            </span>
          </template>
          <template #cell(payment_method)="data">
            <b-badge :variant="data.value === 1 ? 'light-primary' : 'light-info'">
              {{ data.value === 1 ? "Quincenal" : "Mensual" }}
            </b-badge>
          </template>

          <template #cell(tiene_otro_pago)="data">
            <b-badge :variant="data.value === 1 ? 'light-primary' : 'light-warning'">
              {{ data.value === 1 ? "SI" : "NO" }}
            </b-badge>
          </template>

          <!-- <template #cell(pension_fund)="data">
            <span v-if="data.item.type_form == 'Planilla'">
              {{ data.value }}
            </span>
            <b-badge v-else variant="light-danger">
              {{ $t("Not Apply") }}
            </b-badge>
          </template> -->
          <template #cell(month)="data">
            <span class=""> {{ data.value | myGlobal }} </span>
          </template>

          <template #cell(document_number)="data">
            <span class=""> {{ data.value }} </span>
          </template>

          <template #cell(salary_per_month)="data">
            <span class="text-success"> S/ {{ data.value | currency }} </span>
          </template>

          <template #cell(bonification)="data">
            <span class="text-success"> S/ {{ data.value | currency }} </span>
          </template>

          <template #cell(salary_per_day)="data">
            <span> S/ {{ data.value | currency }} </span>
          </template>

          <template #cell(worked_days)="data">
            <span style="opacity: 0.8">{{ data.value }}</span>
          </template>

          <template #cell(not_worked_days)="data">
            <span style="opacity: 0.8">{{ data.value }}</span>
          </template>

          <template #cell(pension_fund)="data">
            <b-badge v-if="data.item.pension_fund_id != null" variant="light-primary">
              {{ data.value }}
            </b-badge>
            <b-badge v-else variant="light-danger">No Aplica</b-badge>
          </template>

          <template #cell(tipo_comision)="data">
            <span v-if="data.item.pension_fund_id != null"
              :class="data.value === 'flujo' ? 'text-primary' : 'text-info'">
              {{ data.value != null ? data.value.toUpperCase() : " - " }}
            </span>
            <span v-else class="text-danger">-</span>
          </template>

          <template #cell(porcentaje_contribucion)="data">
            <span v-if="data.item.pension_fund_id != null && data.value > 0">% {{ data.value }}</span>
            <span v-else> - </span>
          </template>

          <template #cell(monto_contribucion)="data">
            <span v-if="
              data.item.pension_fund_id != null &&
              data.item.monto_contribucion_total > 0
            " class="text-danger">S/ {{ data.item.monto_contribucion_total | currency }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(porcentaje_seguro)="data">
            <span v-if="data.item.pension_fund_id != null && data.value > 0">% {{ data.value }}</span>
            <span v-else> - </span>
          </template>

          <template #cell(monto_seguro)="data">
            <span v-if="
              data.item.pension_fund_id != null &&
              data.item.monto_seguro_total > 0
            " class="text-danger">S/ {{ data.item.monto_seguro_total | currency }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(porcentaje_comision)="data">
            <span v-if="
              data.item.pension_fund_id != null &&
              data.item.tipo_comision == 'mixto'
            ">
              % {{ data.item.porcentaje_comision_mixto }}
            </span>
            <span v-else-if="
              data.item.pension_fund_id != null &&
              data.item.tipo_comision == 'flujo'
            ">
              % {{ data.value }}
            </span>
            <span v-else> - </span>
          </template>

          <template #cell(monto_comision)="data">
            <span v-if="
              data.item.pension_fund_id != null &&
              data.item.monto_comision_total > 0
            " class="text-danger">S/
              {{ data.item.monto_comision_total | currency }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(total_aportaciones)="data">
            <span class="text-danger">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(descuento_x_falta)="data">
            <span class="text-danger">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(descuento_x_tardanza)="data">
            <span class="text-danger">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(other_discounts)="data">
            <span class="text-danger">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(monto_quinta)="data">
            <span class="text-danger">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(total_discount)="data">
            <span class="text-danger">
              S/
              {{ data.item.total_discount | currencyZero }}
            </span>
          </template>

          <template #cell(fortnight_amount)="data">
            <span :class="data.item.payment_method == 1 ? 'text-primary' : 'text-info'
              ">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>

          <template #cell(monthly_amount)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>

          <template #cell(or_salary)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>
          <template #cell(or_bonification)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>
          <template #cell(or_salary_per_day)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>
          <template #cell(or_montlhy_descuento_falta)="data">
            <span class="text-primary">
              S/
              {{
                (parseFloat(data.value) +
                  parseFloat(data.item.or_descuento_x_falta))
                | currencyZero
              }}
            </span>
          </template>
          <template #cell(or_monthly_others_discount)="data">
            <span class="text-primary">
              S/
              {{
                (parseFloat(data.value) +
                  parseFloat(data.item.or_others_discount))
                | currencyZero
              }}
            </span>
          </template>
          <template #cell(or_total_descuento)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>
          <template #cell(or_bono_quincena)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>
          <template #cell(or_bono_mensual)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>

          <template #cell(or_fortnight_amount)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>

          <template #cell(or_total_amount)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>

          <template #cell(payroll_status)="data">
            <b-badge pill :variant="`${resolveStypeStatus(data.item.status_id)}`" class="px-1 py-50">
              <feather-icon icon="InfoIcon" size="12" class="mr-25" />
              {{
                data.item.payroll_status === "Fortnight Pending"
                  ? "Quincena Pendiente"
                  : data.item.payroll_status === "Fortnight Approved"
                    ? "Quincena Aprobada"
                    : data.item.payroll_status === "Fortnight Paid"
                      ? "Quincena Pagada"
                      : data.item.payroll_status === "Salary Pending"
                        ? "Planilla Pendiente"
                        : data.item.payroll_status === "Salary Approved"
                          ? "Planilla Aprobada"
                          : data.item.payroll_status === "Salary Paid"
                            ? "Planilla Pagada"
                            : "Estado no encontrado"
              }}
            </b-badge>
          </template>

          <template #cell(is_ready_approve)="data">
            <b-badge :variant="`light-${data.value == 1 ? 'success' : 'warning'}`">
              {{
                data.value == 1 ? $t("To Approve") : $t("Pending To Calculate")
              }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex align-items-center justify-content-center">
              <b-button v-if="data.item.status_id == 2 || data.item.status_id == 5" 
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="flat-primary" class="btn-icon rounded-circle" size="sm"
                v-b-tooltip.hover.bottom="$t('View Payroll')"
                @click="viewPayroll(data.item)">
                <feather-icon icon="EyeIcon" size="16" />
              </b-button>

              <b-button v-if="data.item.status_id == 1 || data.item.status_id == 4"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-success" class="btn-icon rounded-circle" size="sm"
                v-b-tooltip.hover.bottom="$t('Approve')"
                @click="approvePayroll(data.item)">
                <feather-icon icon="CheckSquareIcon" size="16" />
              </b-button>

              <b-button v-ripple.400="'rgba(255, 159, 67, 0.15)'"
                variant="flat-warning" class="btn-icon rounded-circle" size="sm"
                v-b-tooltip.hover.bottom="$t('View Tracking')"
                @click="showPayrollTracking(data.item)">
                <feather-icon icon="ListIcon" size="16" />
              </b-button>
            </div>
          </template>

          <!-- Footer -->
          <template #custom-foot>
            <!-- Subtotal row -->
            <b-tr :class="isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'">
              <b-td v-for="(field, index) in tableFields" :key="field.key" class="text-center"
                :class="{ 'text-right font-weight-bolder': index === 0 }">
                <template v-if="
                  tableFields[index + 1] &&
                  tableFields[index + 1].key === 'fortnight_amount'
                ">
                  Subtotal
                </template>
                <template v-else-if="field.key === 'fortnight_amount'">
                  S/. {{ subTotalFortnight | currencyZero }}
                </template>
                <template v-else-if="field.key === 'monthly_amount'">
                  S/. {{ subTotalMonthly | currencyZero }}
                </template>
                <template v-else-if="field.key === 'or_fortnight_amount'">
                  S/. {{ orSubtotalFortnight | currencyZero }}
                </template>
                <template v-else-if="field.key === 'or_total_amount'">
                  S/. {{ orSubtotalMonthly | currencyZero }}
                </template>
                <template v-else> &nbsp; </template>
              </b-td>
            </b-tr>

            <!-- Total row -->
            <b-tr :class="isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'">
              <b-td v-for="(field, index) in tableFields" :key="field.key" class="text-center"
                :class="{ 'text-right font-weight-bolder': index === 0 }">
                <template v-if="
                  tableFields[index + 1] &&
                  tableFields[index + 1].key === 'fortnight_amount'
                ">
                  Total
                </template>
                <template v-else-if="field.key === 'fortnight_amount'">
                  S/. {{ totalFortnight | currencyZero }}
                </template>
                <template v-else-if="field.key === 'monthly_amount'">
                  S/. {{ totalMonthly | currencyZero }}
                </template>
                <template v-else-if="field.key === 'or_fortnight_amount'">
                  S/. {{ orTotalFortnight | currencyZero }}
                </template>
                <template v-else-if="field.key === 'or_total_amount'">
                  S/. {{ orTotalMonthly | currencyZero }}
                </template>
                <template v-else> &nbsp; </template>
              </b-td>
            </b-tr>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <PayrollTrackingModal v-if="showPayrollTrackingModal" :payroll="payrollSelected"
      @hideModal="showPayrollTrackingModal = false" />

    <OperationPayrollModal v-if="operationPayrollModal" :payrollId="payrollId" :isView="isView"
      :dataModal="payrollSelected" @hideModal="operationPayrollModal = false" @refreshAndHide="
        operationPayrollModal = false;
      $refs['ref-table-rrhh-operations-payroll'].refresh();
      " @approvePayroll="handleApprovePayroll" />

    <PlanillaProcesamientoModal v-if="showPlanillaProcesamientoModal" :modalData="batchData"
      @close="handleClosePlanillaProcesamientoModal" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Fields from "@/views/rrhh/views/payroll/data/Fields.data.js";
import Filters from "@/views/rrhh/views/payroll/data/Filters.data.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

import PayrollTrackingModal from "@/views/rrhh/views/payroll/components/operations-payroll/payroll-tracking/PayrollTrackingModal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import OperationPayrollModal from "@/views/rrhh/views/payroll/components/modals/OperationPayrollModal.vue";
import PayrollService from "@/views/rrhh/views/payroll/services/payroll.service.js";
import PlanillaProcesamientoModal from "@/views/rrhh/views/payroll/components/administrative-payroll/PlanillaProcesamientoModal.vue";

export default {
  components: {
    FilterSlot,
    PayrollTrackingModal,
    ToastificationContent,
    OperationPayrollModal,
    PlanillaProcesamientoModal,
  },
  data() {
    return {
      showFieldsArray: [],
      filters: Filters,
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      showPayrollTrackingModal: false,
      payrollSelected: {},
      payrollId: null,
      operationPayrollModal: false,
      subTotalFortnight: 0,
      subTotalMonthly: 0,
      orSubtotalFortnight: 0,
      orSubtotalMonthly: 0,
      totalFortnight: 0,
      totalMonthly: 0,
      orTotalFortnight: 0,
      orTotalMonthly: 0,
      showPlanillaProcesamientoModal: false,
      batchData: {
        id: null,
        name: null,
        status: null,
        message: null,
        progress: 0,
        total_jobs: 0,
        processed_jobs: 0,
        pending_jobs: 0,
        failed_jobs: 0,
        failed_job_details: [],
        created_at: null,
        finished_at: null,
        finished: false,
      },
      progressInterval: null,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    showFields() {
      return this.fields.filter((item) => item.visible);
    },
    tableFields() {
      return this.fields.filter((item) =>
        this.showFieldsArray.includes(item.key)
      );
    },
  },
  created() {
    this.fillYears();
    this.fillMonths();
  },
  mounted() {
    this.filters[0].model = moment().format("Y");
    this.filters[1].model = parseInt(moment().format("M"));

    this.$nextTick(() => {
      const saved = localStorage.getItem("fields_operations_payroll_table");

      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed) && parsed.length > 0) {
            this.showFieldsArray = parsed;
            return;
          }
        } catch (e) {
          console.warn("Error parseando localStorage:", e);
        }
      }

      this.showFieldsArray = this.showFields.map((f) => f.key);
    });
  },

  watch: {
    showFieldsArray: {
      handler(val) {
        localStorage.setItem(
          "fields_operations_payroll_table",
          JSON.stringify(val)
        );
      },
      deep: true,
    },
  },

  methods: {
    handleClosePlanillaProcesamientoModal() {
      this.showPlanillaProcesamientoModal = false;
      this.batchData = {
        id: null,
        name: null,
        status: null,
        message: null,
        progress: 0,
        total_jobs: 0,
        processed_jobs: 0,
        pending_jobs: 0,
        failed_jobs: 0,
        failed_job_details: [],
        created_at: null,
        finished_at: null,
        finished: false,
      };
    },
    async handleApprovePayroll(params) {
      this.operationPayrollModal = false;

      this.addPreloader();

      try {
        const { data } = await PayrollService.approveDriverPayroll({
          simular: false,
          planillas: [params],
        });
        const batchId = data.batch_id;

        this.showPlanillaProcesamientoModal = true;

        this.progressInterval = setInterval(async () => {
          try {
            const statusData = await PayrollService.consultarPlanillaConductor(
              batchId
            );

            if (statusData.type === "success") {
              this.batchData = statusData.data;

              if (statusData.data.finished) {
                clearInterval(this.progressInterval);
                this.showToastSuccess("Proceso completado correctamente");
                this.refreshTable();
              }
            }
          } catch (error) {
            clearInterval(this.progressInterval);
            this.showToastError("Error consultando la planilla");
            console.error(error);
          }
        }, 2000);
      } catch (error) {
        this.showToastError(error.response?.data);
      } finally {
        this.removePreloader();
      }
    },
    fillYears() {
      let years = [];
      let startYear = 2023;
      let currentYear = new Date().getFullYear();
      let endYear = currentYear + 1;

      for (let index = startYear; index <= endYear; index++) {
        years.push({ label: index, id: index });
      }
      this.filters[0].options = years;
    },
    fillMonths() {
      let months = [];
      for (let index = 1; index <= 12; index++) {
        months.push({
          label: this.$t(moment(index, "MM").format("MMMM")),
          id: index,
        });
      }
      this.filters[1].options = months;
    },
    resolveStyleRow(item, type) {
      // console.log("item: ", item);
      // console.log("type: ", type);
      // console.log("item.status_id: ", item?.status_id);
      if (!item || type !== "row") return "";
      if ([2, 5].includes(item.status_id)) {
        return "table-info";
      }
    },
    async myProvider(ctx) {
      this.totalFortnight = 0;
      this.totalMonthly = 0;
      this.orTotalFortnight = 0;
      this.orTotalMonthly = 0;
      this.subTotalFortnight = 0;
      this.subTotalMonthly = 0;
      this.orSubtotalFortnight = 0;
      this.orSubtotalMonthly = 0;
      try {
        this.addPreloader();
        let order = 1;
        // console.log("ctx.sortBy", ctx.sortBy);

        switch (ctx.sortBy) {
          case "codigo_empleado":
            order = 94;
            break;
          case "full_name":
            order = 1;
            break;
          case "type_form":
            order = 39;
            break;
          case "payment_method":
            order = 89;
            break;
          case "tiene_otro_pago":
            order = 71;
            break;
          case "salary_per_month":
            order = 10;
            break;
          case "bonification":
            order = 11;
            break;
          case "salary_per_day":
            order = 12;
            break;
          case "worked_days":
            order = 27;
            break;
          case "not_worked_days":
            order = 28;
            break;
          case "pension_fund":
            order = 68;
            break;
          case "tipo_comision":
            order = 49;
            break;
          case "total_aportaciones":
            order = 103;
            break;
          case "descuento_x_falta":
            order = 102;
            break;
          case "other_discounts":
            order = 101;
            break;
          case "monto_quinta":
            order = 104;
            break;
          case "total_discount":
            order = 30;
            break;
          case "fortnight_amount":
            order = 32;
            break;
          case "monthly_amount":
            order = 106;
            break;
          case "or_total_amount":
            order = 84;
            break;
          case "payroll_status":
            order = 95;
            break;
          default:
            order = 1;
            break;
        }
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          year: this.filters[0].model,
          month: this.filters[1].model,
          area: 8, // operaciones (conductores)
          type: this.filters[2].model,
          pago_adicional: this.filters[3].model,
          contrato: this.filters[4].model,
        };
        const { data } = await PayrollService.getPayroll(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;

        if (data.data.length) {
          this.totalFortnight = data.data[0].total_fortnight;
          this.totalMonthly = data.data[0].total_monthly;
          this.orTotalFortnight = data.data[0].or_total_fortnight;
          this.orTotalMonthly = data.data[0].or_total_monthly;
          this.calSubTotal(data.data);
        }
        return data.data;
      } catch (error) {
        console.log(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },

    calSubTotal(items) {
      let subFortnight = 0;
      let subMonthly = 0;
      let orSubFortnight = 0;
      let orSubMonthly = 0;
      console.log("items: ", items);
      items.map((it) => {
        subFortnight += parseFloat(it.fortnight_amount);
        subMonthly += parseFloat(it.total);
        orSubFortnight += parseFloat(it.or_fortnight_amount);
        orSubMonthly += parseFloat(it.or_total_amount);
      });
      this.subTotalFortnight = subFortnight;
      this.subTotalMonthly = subMonthly;
      this.orSubtotalFortnight = orSubFortnight;
      this.orSubtotalMonthly = orSubMonthly;
    },
    async recalculatePayroll(item) {
      try {
        const confirm = await this.showConfirmSwal();
        if (confirm.isConfirmed) {
          this.addPreloader();
          const params = {
            employee_id: item.employee_id,
            payroll_id: item.id,
            user_id: this.currentUser.id,
          };

          const { data } = await PayrollService.calculatePayroll(params);
          if (data.type == "warning") {
            this.showToast(
              "warning",
              "top-right",
              "Warning",
              "CheckIcon",
              data.msg
            );
          } else if (data.type == "success") {
            this.$toast({
              component: ToastificationContent,
              position: "top-center",
              props: {
                title: this.$t("Success"),
                icon: "CoffeeIcon",
                variant: "success",
                text: this.$t(data.message),
              },
            });
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    resolveStypeStatus(status_id) {
      let _style = "light-secondary";
      switch (status_id) {
        case 1:
          _style = "light-secondary";
          break;
        case 2:
          _style = "light-primary";
          break;
        case 3:
          _style = "light-success";
          break;
        case 4:
          _style = "light-secondary";
          break;
        case 5:
          _style = "light-primary";
          break;
        case 6:
          _style = "light-success";
          break;
      }
      return _style;
    },
    showPayrollTracking(item) {
      this.payrollSelected = item;
      this.showPayrollTrackingModal = true;
    },

    approvePayroll(item) {
      this.payrollId = item.id;
      this.payrollSelected = item;
      this.operationPayrollModal = true;
      this.isView = false;
    },

    viewPayroll(item) {
      this.payrollId = item.id;
      this.operationPayrollModal = true;
      this.isView = true;
    },

    refreshTable() {
      this.$refs["ref-table-rrhh-operations-payroll"].refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.card-app-design {
  border-radius: 12px;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(115, 103, 240, 0.08) !important;
  transition: all 0.3s ease-in-out;
  overflow: hidden;

  &:hover {
    box-shadow: 0 8px 25px 0 rgba(115, 103, 240, 0.1) !important;
  }
}

.dropdown-menu-luxury {
  min-width: 340px !important;
  max-width: 400px !important;
  padding: 1rem 0.5rem !important;
  border-radius: 12px !important;
}

::v-deep .b-table {
  thead th {
    background-color: rgba(115, 103, 240, 0.03) !important;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.5px;
    border-bottom: 2px solid rgba(115, 103, 240, 0.08) !important;
    padding: 1rem 0.5rem !important;
  }

  tbody tr {
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(113, 102, 240, 0.04) !important;
      transform: scale(1.001);
    }
  }

  td {
    vertical-align: middle !important;
    padding: 0.75rem 0.5rem !important;
  }
}

.custom-scrollbar {
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(115, 103, 240, 0.2);
    border-radius: 10px;
    &:hover {
      background: rgba(115, 103, 240, 0.4);
    }
  }
}

.dark-layout {
  .card-app-design {
    background-color: #161d31 !important;
    border-color: rgba(255, 255, 255, 0.05) !important;
  }

  .dropdown-menu-luxury {
    background-color: #161d31 !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    .text-body {
      color: #d0d2d6 !important;
    }
    .dropdown-header {
      background-color: transparent !important;
    }
  }

  ::v-deep .b-table {
    thead th {
      background-color: rgba(255, 255, 255, 0.03) !important;
    }
    tbody tr:hover {
      background-color: rgba(255, 255, 255, 0.05) !important;
    }
  }

  .bg-dark td, .bg-white td {
    background-color: #1e2846 !important;
    color: #d0d2d6 !important;
    border-top: 2px solid rgba(255, 255, 255, 0.05) !important;
  }
}
</style>

<style>
.sticky-data {
  position: sticky;
  bottom: 0;
  z-index: 1000;
}
</style>